export const formatDateTime = (dateString) => {
  const dt = new Date(dateString);

  const datePart = dt
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, "-");

  const timePart = dt.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  return (
    <div>
      <span>{datePart.toUpperCase()}</span>
      <br />
      <span>{timePart}</span>
    </div>
  );
};
